import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

interface PlatformPermissionPayload {
  platform: string;
  accountKey: string;
  platformUserId: string;
}

/**
 * Save platform permission for a specific platform/account.
 */
export const savePlatformPermission = async (
  accessAuthToken: string,
  payload: PlatformPermissionPayload
): Promise<{ platformPermissionOptIn: boolean }> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/users/platform-permission`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessAuthToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to save platform permission");
    }

    return await response.json();
  } catch (error) {
    console.error("Error saving platform permission:", error);
    showErrorToast("Failed to save platform permission");
    throw error;
  }
};

